import React from 'react';
import PropTypes from 'prop-types';
import { withSiteData } from 'react-static';

import styled from 'styled-components';

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share';

import FacebookMessengerShareButton from './FacebookMessengerShareButton';
import FacebookMessengerIcon from './FacebookMessengerIcon';

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  padding-bottom: 2rem;
  padding-top: 2rem;

  > :not(:last-child) {
    margin-right: 0.5rem;
  }

  .SocialMediaShareButton {
    cursor: pointer;
    display: inline-block;
    margin-right: calc(var(--fr) * 0.5);
    text-align: center;
    vertical-align: middle;
  }

  .SocialMediaShareButton:hover:not(:active) {
    opacity: 0.75;
  }
`;

class ShareButtons extends React.Component {
  render() {
    const shareUrl = `${this.props.baseUrl}/${this.props.path}`;
    const iconSize = 48;
    const { isMobile } = this.context;
    const iconBgStyle = { fill: 'var(--c-shark)' };

    return (
      <Wrapper>
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={iconSize} round iconBgStyle={iconBgStyle} />
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={iconSize} round iconBgStyle={iconBgStyle} />
        </TwitterShareButton>
        <LinkedinShareButton url={shareUrl}>
          <LinkedinIcon size={iconSize} round iconBgStyle={iconBgStyle} />
        </LinkedinShareButton>
        {isMobile && (
          <React.Fragment>
            <WhatsappShareButton url={shareUrl}>
              <WhatsappIcon size={iconSize} round iconBgStyle={iconBgStyle} />
            </WhatsappShareButton>

            <FacebookMessengerShareButton url={shareUrl} appId="642978282525451">
              <FacebookMessengerIcon size={iconSize} round iconBgStyle={iconBgStyle} />
            </FacebookMessengerShareButton>
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

ShareButtons.contextTypes = {
  isMobile: PropTypes.bool,
};

ShareButtons.propTypes = {
  path: PropTypes.string,
  baseUrl: PropTypes.string,
};

export default withSiteData(ShareButtons);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ShareButtons.js